export default "/public/img/GT-America-Medium.799691d8.otf";